'use client';

import type { FragmentType } from 'src/gql';
import { DialogDescription, DialogHeader, DialogTitle } from '@savvy-kit/components/dialog';
import { Spinner } from '@savvy-kit/components/spinner';
import TrackedDialog from 'src/components/tracked/tracked-dialog';
import { unmaskFragment } from 'src/gql';

import { TaxEnrollmentForm } from './tax-enrollment-form';
import { TaxEnrollmentFormFragment } from './tax-enrollment-form-fragment';

type TaxEnrollmentDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly householdFrag: FragmentType<typeof TaxEnrollmentFormFragment> | undefined;
  readonly loading: boolean;
};

export function TaxEnrollmentDialog({ open, onClose, householdFrag, loading }: TaxEnrollmentDialogProps) {
  const household = unmaskFragment(TaxEnrollmentFormFragment, householdFrag);
  const hasExistingEnrollments = (household?.taxEnrollments?.length ?? 0) > 0;

  return (
    <TrackedDialog
      elementName="form-dialog"
      open={open}
      onOpenChange={(nextOpen) => !nextOpen && onClose()}
      className="sm:max-w-[676px]"
    >
      <DialogHeader>
        <DialogTitle>{hasExistingEnrollments ? 'Edit tax enrollment' : 'Register household'}</DialogTitle>
        <DialogDescription>{`Choose the filing type and price for this household's tax return`}</DialogDescription>
      </DialogHeader>
      {loading ? (
        <div className="flex items-center justify-center pb-8 h-[250px]">
          <Spinner className="size-6 text-primary" />
        </div>
      ) : (
        <TaxEnrollmentForm householdFrag={householdFrag} onClose={onClose} />
      )}
    </TrackedDialog>
  );
}
